export default "__VITE_ASSET__BRMOSFAb__"